<template>
  <div class="dh-psy-chapter">
    <span v-html="item.value" />
  </div>
</template>

<style scoped lang="postcss">
  .dh-psy-chapter {
    text-align: center;
    font-family: LFT Etica;
    font-weight: 400;
    color: #777;
    text-transform: uppercase;
    font-size: 0.8em;
    margin: 0;
    padding-top: 125px;
    padding-bottom: 20px;

    @media (min-width: 900px) {
    }
  }
</style>

<script>
export default {
  props: ['item']
}
</script>
